/**
 * Dashboard greeting — a time-of-day salutation with the person's FIRST name,
 * and the weekday + date. Shown at the top of every role's home (admin, field
 * staff, customer), so whoever opens the app is greeted by name.
 *
 * The salutation and date use the DEVICE's local clock on purpose: it is the
 * time in front of the person, which is what "good morning" should track.
 */
import { useAuth } from '../lib/auth';

function saluteFor(hour: number): string {
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
}

/** First word of the name, Title-Cased (names are often stored ALL CAPS). */
function firstName(full: string | undefined): string {
  const first = (full ?? '').trim().split(/\s+/)[0] ?? '';
  if (!first) return 'there';
  return first.charAt(0).toUpperCase() + first.slice(1).toLowerCase();
}

export function Greeting() {
  const { user } = useAuth();
  const now = new Date();
  const dayDate = now.toLocaleDateString('en-IN', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  });
  return (
    <div className="greeting">
      <div className="greeting__hi">{saluteFor(now.getHours())}, {firstName(user?.fullName)}</div>
      <div className="greeting__date">{dayDate}</div>
    </div>
  );
}
